import { Action, Selector, State, StateContext, Store } from '@ngxs/store';
import { Observable, of } from 'rxjs';
import { catchError, tap } from 'rxjs/operators';
import { NotificationService } from '../../../../../../common/services';
import { AllocationViewDepartureDockModel } from '../../models';
import { HttpErrorResponse } from '@angular/common/http';
import {
  AllocationViewReleaseFromDockActionPrepare,
  AllocationViewReleaseFromDockAction,
  AllocationViewReleaseFromDockActionSetInitialState,
} from './allocation-view-release-from-dock-action.actions';
import { AllocationViewReleaseFromDockActionService } from './allocation-view-release-from-dock-action.service';
import { Injectable } from '@angular/core';
import { AllocationViewActionBaseState } from '../base';
import { MatSnackBarRef, SimpleSnackBar } from '@angular/material/snack-bar';

export interface AllocationViewReleaseFromDockActionStateModel {
  loaded: boolean;
  dockDeparturePreparedData: AllocationViewDepartureDockModel;
}

const initialState: AllocationViewReleaseFromDockActionStateModel = {
  loaded: false,
  dockDeparturePreparedData: null,
};

@State({
  name: 'allocationViewActionsReleaseFromDock',
  defaults: initialState,
})
@Injectable()
export class AllocationViewReleaseFromDockActionState extends AllocationViewActionBaseState {
  @Selector()
  static getLoaded(state: AllocationViewReleaseFromDockActionStateModel): boolean {
    return state.loaded;
  }

  @Selector()
  static getDockDeparturePreparedData(
    state: AllocationViewReleaseFromDockActionStateModel,
  ): AllocationViewDepartureDockModel {
    return state.dockDeparturePreparedData;
  }

  constructor(
    private allocationViewReleaseFromDockActionService: AllocationViewReleaseFromDockActionService,
    notificationService: NotificationService,
    store: Store,
  ) {
    super(notificationService, store);
  }

  @Action(AllocationViewReleaseFromDockAction)
  dockDepartureConfirmation(
    ctx: StateContext<AllocationViewReleaseFromDockActionStateModel>,
    { data }: AllocationViewReleaseFromDockAction,
  ): Observable<MatSnackBarRef<SimpleSnackBar> | void> {
    return this.allocationViewReleaseFromDockActionService.dockDeparture(data).pipe(
      tap(() => {
        this.finishAction('api.uli.success.dockDeparture');
      }),
      catchError(({ error }: HttpErrorResponse) => of(this.notificationService.error(error.message))),
    );
  }

  @Action(AllocationViewReleaseFromDockActionPrepare)
  dockDepartureConfirmationPrepare(
    ctx: StateContext<AllocationViewReleaseFromDockActionStateModel>,
    { identifier, language }: AllocationViewReleaseFromDockActionPrepare,
  ): Observable<MatSnackBarRef<SimpleSnackBar> | AllocationViewDepartureDockModel> {
    return this.allocationViewReleaseFromDockActionService.dockDeparturePrepare(identifier, language).pipe(
      tap((response: AllocationViewDepartureDockModel) => {
        ctx.patchState({
          dockDeparturePreparedData: response,
          loaded: true,
        });
      }),
      catchError(({ error }: HttpErrorResponse) => of(this.notificationService.error(error.message))),
    );
  }

  @Action(AllocationViewReleaseFromDockActionSetInitialState)
  setInitialState(ctx: StateContext<AllocationViewReleaseFromDockActionStateModel>): void {
    ctx.setState(initialState);
    this.setContainerAfterActionEffectsInitialState();
  }
}
